import type { ReactNode } from 'react';

export const symbol_screen_search_desktop: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M458-420q22.09 0 41.54-7.5Q519-435 538-446l69 69q7 7 16 7t16-6.59q7-7.41 7-16.41t-7-16l-72-72q11-17 18.5-35.36Q593-534.71 593-555q0-57-39-96t-96-39q-57 0-96 39.08-39 39.07-39 96Q323-498 362-459t96 39Zm.04-50Q423-470 398-494.96q-25-24.95-25-60Q373-590 397.97-615T458-640q35 0 60 24.96 25 24.95 25 60Q543-520 518.04-495q-24.95 25-60 25ZM70-120q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q57.25-180 70-180h820q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H70Zm70-120q-24 0-42-18t-18-42v-480q0-24 18-42t42-18h680q24 0 42 18t18 42v480q0 24-18 42t-42 18H140Zm0-60h680v-480H140v480Zm0 0v-480 480Z"
		/>
	</svg>
);
